import RolexPage from '@components/_rolex/Page'
import { Page } from '@components/Page'
import { buildLanguageAlternateNavigation } from '@lib/build-language-alternates'
import { GetStaticProps, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

function useRolexCorner(language: string) {
  useEffect(() => {
    // Remove any existing script tags
    const existingScript = document.getElementById('rolex-corner-script')
    if (existingScript) {
      existingScript.remove()
    }

    // Remove any existing corner elements
    const existingCorner = document.querySelector('#rlxCorner')
    if (existingCorner) {
      existingCorner.innerHTML = ''
    }

    // Reset callback
    window.rlxCornerCallback = (Corner) => {
      const corner = new Corner({
        as: 'standalone',
        lang: language === 'nl' ? 'nl' : 'en',
        consent: false,
        legal: '',
        destination: 'new-watches-2025',
      })
      corner.mount('#rlxCorner')
    }

    // Manually inject the script
    const script = document.createElement('script')
    script.id = 'rolex-corner-script'
    script.src =
      'https://cornersv7.rolex.com/retailer.js?apikey=3749a28a87220925506fa122a876c80e&callback=rlxCornerCallback'
    document.body.appendChild(script)

    return () => {
      delete window.rlxCornerCallback
      script.remove()
    }
  }, [language])
}

const NewWatches2025: NextPage = () => {
  const { locales } = useRouter()
  const {
    t,
    i18n: { language },
  } = useTranslation('rolex')

  useRolexCorner(language)

  return (
    <Page
      title={t('navigation.newWatches2025')}
      languageAlternates={buildLanguageAlternateNavigation(
        locales,
        'rolex.newWatches2025',
        '/rolex',
      )}
    >
      <RolexPage>
        <div id="rlxCorner" />
      </RolexPage>
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale: lang }) => {
  const language = lang === 'sg' ? 'en' : lang
  return {
    props: {
      ...(await serverSideTranslations(language, [
        'footer',
        'footer-items',
        'navigation',
        'other',
        'global',
        'rolex',
        'cookies',
        'forms',
        'dropdown',
        'dropdown-items',
      ])),
    },
  }
}

export default NewWatches2025
